import { render } from "./EditableField.vue?vue&type=template&id=21b38478&scoped=true"
import script from "./EditableField.vue?vue&type=script&lang=js"
export * from "./EditableField.vue?vue&type=script&lang=js"

import "./EditableField.vue?vue&type=style&index=0&id=21b38478&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b38478"]])

export default __exports__